import * as React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from 'mkui-fd';
export default function CategoryItem(props) {
  var prefixCls = props.prefixCls,
      batchAddBtn = props.batchAddBtn,
      name = props.name,
      children = props.children,
      onBatchClick = props.onBatchClick;

  function batchHandle(e) {
    if (onBatchClick) {
      onBatchClick();
    }
  }

  return React.createElement("ul", {
    className: prefixCls
  }, React.createElement("span", {
    className: "".concat(prefixCls, "-item")
  }, React.createElement("span", {
    className: "".concat(prefixCls, "-item-name"),
    title: name
  }, name), batchAddBtn ? React.createElement(Button, {
    className: "".concat(prefixCls, "-item-add-btn"),
    type: "link",
    onClick: function onClick(event) {
      batchHandle(event);
    }
  }, "\u6DFB\u52A0\u6240\u6709") : null), children);
}
CategoryItem.propTypes = {
  prefixCls: PropTypes.string
};
CategoryItem.defaultProps = {
  prefixCls: 'mkui-transfer-modal-category'
};
//# sourceMappingURL=CategoryItem.js.map
